export default "__VITE_ASSET__B_MQ0xl6__"